<script lang="ts" module>
	export interface IconLinkProps {
		href: string;
		label: string;
		dataCy: string;
		children?: import('svelte').Snippet;
		onclick?: () => void;
		class?: string;
		target?: string;
		rel?: string;
	}
</script>

<script lang="ts">
	import { Link } from '../Link';

	let { href, label, dataCy, children, onclick, ...rest }: IconLinkProps = $props();
</script>

<Link {href} aria-label={label} {...rest} data-cy={`${dataCy}-icon-link`} {onclick}>
	{@render children?.()}
</Link>
